module.exports = __webpack_public_path__ + "static/media/photo237.df7474e2.jpg";